import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {DeferredElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/deferred_element.types';
import {NavigationPageService_GetCategoryHighlightElementLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation_page/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../../../../shared-deprecated/useTargetGroupIdentifier';

export const useGetCategoryHighlightCardProducts = ({
  deferred,
  disabled,
}: {
  deferred: DeferredElement;
  disabled?: boolean;
}) => {
  const session = useFullSession();
  const targetGroup = useTargetGroupIdentifier();
  const reductionsState = useReductionsStateRequestParameter();

  return useGrpcRequest(
    NavigationPageService_GetCategoryHighlightElementLazy,
    {
      session: session!,
      targetGroup,
      reductionsState,
      deferred,
    },
    {disabled: !session || disabled},
  );
};
